import { render, staticRenderFns } from "./ArtistsGeneralInformation.vue?vue&type=template&id=c673cbb8&"
import script from "./ArtistsGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./ArtistsGeneralInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports